import { api } from "api/api";
import { AxiosError } from "axios";
import Produto from "model/administracao/cadastro/produto/Produto";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Estagio from "model/producao/Estagio";
import ItemPedido from "model/producao/ItemPedido";
import LigarOpPedido from "model/producao/LigarOpPedido";
import OrdemProducao from "model/producao/OrdemProducao";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class GerarOpService implements BaseServiceCadastros<ItemPedido> {

    pesquisar(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemPedido/pesquisar/gerarOP`;
            if(filters){
                url += getFilters(filters);
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarItensFechados(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemPedido/pesquisar/itensFechados`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarItensAbertos(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemPedido/pesquisar/itensAbertos`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarOpsSemPedido(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemPedido/pesquisar/opsSemPedido`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ItemPedido>((resolve, reject): void => { });
    }

    incluir(estagio: ItemPedido) {
        return new Promise<ItemPedido>((resolve, reject): void => {
        });
    }

    editar(estagio: ItemPedido) {
        return new Promise<ItemPedido>((resolve, reject): void => { });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => { });
    }

    gerarOps(item: ItemPedido) {
        return new Promise<OrdemProducao[]>((resolve, reject): void => {
            const url = `/itemPedido/gerarOP`;
            api
                .post(url, item)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gerarOp(ordemProducao: OrdemProducao) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            const url = `/ordemProducao/gerar`;
            api
                .post(url, ordemProducao)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));

        });

    }
    getProdutosProduzidos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/ordemProducao/produtosProduzidos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    reabrirItemPedido(id: number){
        return new Promise<void>((resolve, reject): void => {
            const url = `/itemPedido/reabrirItemPedido/${id}`;
            api
                .put(url)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    ligarOpPedido(ligarOpPedido: LigarOpPedido){
        return new Promise<void>((resolve, reject): void => {
            const url = `/itemPedido/ligarOpPedido`;
            api
                .put(url, ligarOpPedido)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default GerarOpService;